var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFinalidade = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#F3F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.02334 10.3237C8.32509 11.6254 10.1191 11.942 11.0303 11.0308C11.9415 10.1195 11.6249 8.32558 10.3232 7.02383C9.02143 5.72208 7.22746 5.4055 6.31624 6.31672C5.40501 7.22795 5.72159 9.02191 7.02334 10.3237ZM9.40497 10.194C9.8345 10.2698 10.024 10.1515 10.0875 10.088C10.151 10.0244 10.2693 9.83498 10.1935 9.40546C10.1186 8.981 9.86152 8.4478 9.38036 7.96664C8.89921 7.48548 8.36601 7.22836 7.94154 7.15346C7.51202 7.07766 7.32256 7.19601 7.25904 7.25953C7.19552 7.32305 7.07717 7.51251 7.15297 7.94203C7.22787 8.3665 7.485 8.8997 7.96615 9.38085C8.44731 9.86201 8.98051 10.1191 9.40497 10.194Z",
    fill: "#696F88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3804 18.0372C12.1586 18.5137 13.8706 17.8908 14.2041 16.6461C14.5376 15.4013 13.3665 14.006 11.5882 13.5295C9.81003 13.0531 8.09811 13.6759 7.76458 14.9206C7.43105 16.1654 8.60221 17.5607 10.3804 18.0372ZM12.3782 16.7341C12.788 16.585 12.8929 16.3878 12.9162 16.301C12.9394 16.2142 12.9472 15.991 12.6668 15.6569C12.3897 15.3268 11.9004 14.9936 11.2432 14.8174C10.5859 14.6413 9.99556 14.6853 9.59051 14.8326C9.18063 14.9817 9.07573 15.179 9.05248 15.2657C9.02924 15.3525 9.02147 15.5757 9.30187 15.9098C9.57897 16.24 10.0682 16.5732 10.7255 16.7493C11.3828 16.9254 11.9731 16.8815 12.3782 16.7341Z",
    fill: "#696F88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1781 13.0308C14.0893 13.942 15.8833 13.6254 17.185 12.3237C18.4867 11.0219 18.8033 9.22795 17.8921 8.31672C16.9809 7.4055 15.1869 7.72208 13.8852 9.02383C12.5834 10.3256 12.2668 12.1195 13.1781 13.0308ZM14.1209 12.088C14.1844 12.1515 14.3738 12.2698 14.8034 12.194C15.2278 12.1191 15.761 11.862 16.2422 11.3809C16.7233 10.8997 16.9805 10.3665 17.0554 9.94203C17.1312 9.51251 17.0128 9.32305 16.9493 9.25953C16.8858 9.19601 16.6963 9.07766 16.2668 9.15346C15.8423 9.22836 15.3091 9.48548 14.828 9.96664C14.3468 10.4478 14.0897 10.981 14.0148 11.4055C13.939 11.835 14.0574 12.0244 14.1209 12.088Z",
    fill: "#696F88"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFinalidade);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Finalidade.b0bd221779725bf83d0c47685aa72804.svg";